import gql from 'graphql-tag';

const DELETE_CONTRACT_TEMPLATE_NEW = gql`
  mutation deleteBillingContractTemplate($input: ContractIdentifierInput!) {
    deleteBillingContractTemplate(input: $input)
  }
`;

const CREATE_CONTRACT_TEMPLATE_NEW = gql`
  mutation createBillingContractTemplate($input: CreateContractTemplateInput!) {
    createBillingContractTemplate(input: $input) {
      contract {
        contractId
        name
        description
      }
    }
  }
`;

const UPDATE_CONTRACT_TEMPLATE_NEW = gql`
  mutation updateBillingContractTemplate($input: UpdateContractTemplateInput!) {
    updateBillingContractTemplate(input: $input) {
      contract {
        contractId
        name
        description
      }
    }
  }
`;

export {
  CREATE_CONTRACT_TEMPLATE_NEW,
  UPDATE_CONTRACT_TEMPLATE_NEW,
  DELETE_CONTRACT_TEMPLATE_NEW
};
